document.addEventListener('DOMContentLoaded', initProductFaqNkten);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initProductFaqNkten);
}

function initProductFaqNkten(event) {
  const root = event && event.target && event.target.querySelector
    ? event.target.querySelector('[data-nk-faq]')
    : document.querySelector('[data-nk-faq]');

  const sections = root ? [root] : document.querySelectorAll('[data-nk-faq]');

  sections.forEach((section) => {
    if (!section || section.dataset.nkFaqInitialized) return;
    section.dataset.nkFaqInitialized = 'true';

    const items = section.querySelectorAll('.nk-faq__item');

    items.forEach((item) => {
      const trigger = item.querySelector('[data-nk-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((otherItem) => {
          otherItem.classList.remove('is-open');
          const otherTrigger = otherItem.querySelector('[data-nk-faq-trigger]');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}
